import React from 'react';
import { Trans } from 'ui';
import Link from 'components/common/Link';
import { Checkbox } from '../Checkbox';
import { Flex } from 'components/layout';

const n = (s, ns = 'signUp') => ` .${ns}.${s}`;

const signUpStrings = {
  signup: {
    title: {
      id: n('title'),
      defaultMessage: 'Регистрация в YouThink',
    },
    alternateOffer: {
      id: n('loginLink'),
      defaultMessage: 'Войти',
    },
    email: {
      id: n('email'),
      defaultMessage: 'Электронная почта',
    },
    password: {
      id: n('password'),
      defaultMessage: 'Пароль',
    },
    cta: {
      id: n('cta'),
      defaultMessage: 'Создать новый аккаунт',
    },
  },
  login: {
    title: {
      id: n('title', 'login'),
      defaultMessage: 'Вход в YouThink',
    },
    alternateOffer: {
      id: n('signupOffer', 'login'),
      defaultMessage: 'Регистрация',
    },
    cta: {
      id: n('cta', 'login'),
      defaultMessage: 'Войти',
    },
    restorePassword: {
      id: n('restorePasswordCta', 'login'),
      defaultMessage: 'Забыли пароль?',
    },
  },
  restore: {
    success: {
      id: n('success', 'restore'),
      defaultMessage: 'Мы отправили письмо с инструкциями по восстановлению пароля на указанную почту',
    },
    failed: {
      id: n('failed', 'restore'),
      defaultMessage: 'К сожалению такого email не существует. Попробуйте связаться с нами, описав проблему',
    },
  },
};

export const LegalString = ({ checked, ...otherProps }: { checked: boolean; onClick: any }) => (
  <Trans id={n('legal')}>
    <Flex {...otherProps}>
      <Checkbox checked={checked} />
      <div>
        Я согласен с
        {' '}
        <Link target="_blank" colored href="/privacy">
          политикой конфиденциальности
        </Link>
        {' '}
    и
        {' '}
        <Link target="_blank" colored href="/terms">
          условиями использования
        </Link>
        {' '} и <Link target="_blank" colored href="/legal/ru/privacy_agreement">даю согласие на обработку моих персональных данных</Link>{' '}
    YouThink
    </div>
  </Flex>
  </Trans>
);

export default signUpStrings;
